import get from 'lodash/get';
import { request } from 'client/modules/common/utils/request';
import { logInfo } from 'client/modules/common/utils/logInfo';
import { setToastError } from 'client/modules/third-party-admin/profile-queue/utils';

export function clearDealQueue(): Promise<boolean> {
  return request({
    url: '/service/newsqueueservice/ClearDealReviewQueue',
    body: {},
  })
    .then(({ body }) => Boolean(get(body, 'success', false)))
    .catch((error) => {
      setToastError('Error Clearing Deal Queue');
      logInfo({
        error,
        message: 'Deal Queue: Failed To Clear Queue',
        method: 'clearDealQueue',
      });
      throw error;
    });
}
